import { Subscription } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomText,
  CustomHeaderText,
  TextsListColumn,
  UserSubscriptionMovileView
} from 'src/components'

const subcriptionColumns: ColumnsType<Subscription> = [
  {
    title: () => <CustomHeaderText text=' ' />,
    responsive: ['sm'],
    render: (_, subscription) => <CustomText label={subscription.mainlabel} strong />
  },
  {
    title: () => <CustomHeaderText text='Subscription.BASIC_PLAN' />,
    responsive: ['sm'],
    render: (_, subscription) => <CustomText label={subscription.basicPlanLabel} type='secondary' />
  },

  {
    title: () => <CustomHeaderText text='Subscription.API_PRO' />,
    responsive: ['sm'],
    render: (_, subscription) => <TextsListColumn texts={subscription.proPlanLabels} />
  },

  {
    title: () => <CustomHeaderText text='Subscription.PREMIUM_PLAN' />,
    responsive: ['sm'],
    render: (_, subscription) => <TextsListColumn texts={subscription.premiumPlanLabels} />
  },

  {
    title: () => <CustomHeaderText text='Subscription.Title' />,
    responsive: ['xs'],
    render: (_, subscription) => <UserSubscriptionMovileView subscription={subscription} />
  },
]

export default subcriptionColumns
